import { defineStore } from "pinia";
import competitorResultsApi, { ResultsReportOptions, ResultsSortingEnum } from "../../Api/competitorResultsApi";

export const useCompetitorResultsOptionsStore = defineStore("competitor-results-options-store", {
    state() {
        return {
            resultOptions: {
                fullList: false,
                roundRobinWithTwo3rdPlaces: false,
                doubleEliminationWrestlingRules: false,
                resultsSorting: ResultsSortingEnum.EndTime,
            } as ResultsReportOptions,
        };
    },
    actions: {
        loadResultsReportOptions(eventId: number): Promise<void> {
            return competitorResultsApi.getResultsReportOptions(eventId).then(options => {
                this.resultOptions = options;
            });
        },
        saveResultsReportOptions(eventId: number, options: ResultsReportOptions): Promise<void> {
            return competitorResultsApi.savePublicResultsReportOptions(eventId, options);
        },
    },
});
